import { canonicalStockSearch } from "./stockSearch";
const ORIGINAL_BRANDS = new Set(["VW ORİJİNAL", "PORSCHE ORİJİNAL"]);
export function groupUnavailableOriginal(items, searchTerm = "") {
  const searched = canonicalStockSearch(searchTerm).replace(/,$/, "").trim();
  const isDirect = (item) => canonicalStockSearch(item.kod || "").trim() === searched;
  const referenceTokens = (item) => new Set(
    [item.kod, item.oem_kodu, item.degisen_no, item.oem_no1, item.oem_no2]
      .flatMap((value) => String(value || "").split(/[,;\n]+/))
      .map((value) => canonicalStockSearch(value).replace(/,$/, "").trim())
      .filter((value) => value.length >= 3)
  );
  const originalItems = items.filter((item) => ORIGINAL_BRANDS.has(String(item.marka || "").trim().toUpperCase()));
  const parent = new Map(originalItems.map((item) => [item.id, item.id]));
  const find = (id) => {
    let root = id;
    while (parent.get(root) !== root) root = parent.get(root);
    while (parent.get(id) !== id) { const next = parent.get(id); parent.set(id, root); id = next; }
    return root;
  };
  const unite = (a, b) => { const rootA = find(a); const rootB = find(b); if (rootA !== rootB) parent.set(rootB, rootA); };
  const tokenOwner = new Map();
  originalItems.forEach((item) => referenceTokens(item).forEach((token) => {
    const brand = String(item.marka || "").trim().toUpperCase();
    const scopedToken = `${brand}\u0000${token}`;
    if (tokenOwner.has(scopedToken)) unite(item.id, tokenOwner.get(scopedToken));
    else tokenOwner.set(scopedToken, item.id);
  }));
  const groups = new Map(); const output = [];
  originalItems.forEach((item) => {
    const key = find(item.id);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });
  const emitted = new Set();
  items.forEach((item) => {
    const brand = (item.marka || "").trim().toUpperCase();
    if (!ORIGINAL_BRANDS.has(brand)) { output.push(item); return; }
    const key = find(item.id);
    if (emitted.has(key)) return;
    emitted.add(key);
    const members = groups.get(key) || [];
    if (!members.length) return;
    const byCode = new Map(members.map((member) => [String(member.kod || "").trim().toUpperCase(), member]));
    const isSuperseded = (member) => {
      const replacement = byCode.get(String(member.degisen_no || "").trim().toUpperCase());
      return replacement && replacement.id !== member.id && Number((replacement.stok_durumu ?? replacement.stok_miktari) || 0) > 0;
    };
    const exact = members.filter(isDirect);
    const available = members.filter((member) => Number((member.stok_durumu ?? member.stok_miktari) || 0) > 0 && !isSuperseded(member) && !exact.includes(member));
    const visible = [...exact, ...available];
    const unavailable = members.filter((member) => !visible.includes(member)).map((member) =>
      isSuperseded(member) ? { ...member, _effectiveStock: 0 } : member);
    if (visible.length > 0) {
      visible.forEach((item, index) => output.push(index === 0 && unavailable.length > 0
        ? { ...item, _alternatives: unavailable }
        : item));
    } else if (unavailable.length > 0) {
      output.push(unavailable.length > 1
        ? { ...unavailable[0], _alternatives: unavailable.slice(1) }
        : unavailable[0]);
    }
  });
  return output;
}

